import {
	authControllerLoginPreviewV1,
	authControllerLoginV1,
	setChatbotApiAccessToken,
} from "@virtual-brain-lib/frontend-api";

import { setAccessToken } from "./storage";

export async function authenticate(chatId: string) {
	const token = new URLSearchParams(window.location.search).get("access_token") as
		| string
		| undefined;
	const preview = Boolean(
		new URLSearchParams(window.location.search).get("preview") as string | undefined,
	);

	let response;

	if (preview && token) {
		response = await authControllerLoginPreviewV1(chatId, {
			headers: { Authorization: `Bearer ${token}` },
		});
	} else {
		response = await authControllerLoginV1(chatId);
	}

	const { accessToken } = response;

	setAccessToken(chatId, accessToken, preview);
	setChatbotApiAccessToken(accessToken);

	return {
		accessToken,
	};
}
